export default "__VITE_ASSET__CDpD_OKd__"